import React from 'react';
import { AlertCircle } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error,
      errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Navbar />
          <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white flex items-center justify-center px-4 py-20">
            <div className="text-center max-w-lg bg-white p-8 rounded-lg shadow-lg border border-red-300">
              <div className="mb-6">
                <AlertCircle className="w-16 h-16 text-red-600 mx-auto mb-4" />
                <h1 className="text-3xl font-extrabold text-gray-900 mb-2">Terjadi Kesalahan</h1>
                <p className="text-red-600">Aplikasi mengalami kesalahan yang tidak terduga</p>
              </div>

              <div className="bg-gray-100 rounded p-4 mb-6 text-left max-h-48 overflow-y-auto border border-gray-300">
                <p className="text-gray-700 text-xs font-mono whitespace-pre-wrap">
                  {this.state.error?.toString()}
                </p>
              </div>

              <div className="flex gap-4 flex-col justify-center">
                <button
                  onClick={() => window.location.href = '/'}
                  className="px-6 py-3 bg-brand text-navy font-semibold rounded-full hover:bg-brand-dark transition-colors"
                >
                  Kembali ke Beranda
                </button>
                <button
                  onClick={() => window.location.reload()}
                  className="px-6 py-3 bg-gray-300 text-gray-900 font-semibold rounded-full hover:bg-gray-400 transition-colors"
                >
                  Muat Ulang Halaman
                </button>
              </div>

              <p className="text-gray-500 text-xs mt-6">
                Jika masalah terus berlanjut, silahkan hubungi tim support.
              </p>
            </div>
          </div>
          <Footer />
        </>
      );
    }

    return this.props.children;
  }
}
